import React from 'react';
import './style.sass';

import BoxNuestraCompania from '../Upperfooter/BoxNuestraCompania';
import BoxDejanosAyudarte from '../Upperfooter/BoxDejanosAyudarte/index.js';
import BoxPoliticasSears from '../Upperfooter/BoxPoliticasSears';
import BoxRedes  from '../Upperfooter/BoxRedes';

export default function UpperFooter() {
    return (
        <div className="upperfooter">
            <BoxNuestraCompania />
            <BoxPoliticasSears />
            <BoxRedes />
            <BoxDejanosAyudarte />
        </div>
    )
}